import { useEffect, useState } from 'react';
import type { AxiosResponseErrorModel } from 'shared/lib/api';
import { FormErrors } from 'shared/ui/FormErrors';
import { isValidationErrorsModel } from 'shared/lib/api';
import { getKeys } from 'shared/lib/object';

export function EmailsEditorErrors({ error }: { error: AxiosResponseErrorModel | null }) {
  const [errors, setErrors] = useState<AxiosResponseErrorModel | null>(null);

  useEffect(() => {
    if (error && isValidationErrorsModel(error.response.data)) {
      const errors = error.response.data.errors;

      getKeys(errors).forEach((key) => {
        errors[`emails.${Number(key.replace(/\D/g, ''))}.value`] = errors[key];
        delete errors[key];
      });
    }
    setErrors(error);
  }, [error]);

  return <FormErrors error={errors} />;
}
